<template>
  <v-container fluid>
    <v-row
      class="asc-custom-alerts--header justify-end"
      :class="{ isSticky: isSticky }"
      no-gutters
    >
      <v-col class="customAlertControls" cols="6">
        <asc-accent-button
          :outline="!getSaveDisabled"
          secondary
          :on-click="handleCancel"
          button-text="Cancel"
          :disabled="getSaveDisabled || isDataBricksRunning || isReadOnly"
        ></asc-accent-button>
        <asc-accent-button
          :button-text="getButtonText"
          :on-click="handleSave"
          :loading="saveLoading"
          :disabled="getSaveDisabled || isDataBricksRunning || isReadOnly"
        ></asc-accent-button>
        <asc-tooltip :key="1" left :tooltip="getTooltip" :tooltip-length="0">
          <asc-switch
            label="Activate"
            :disabled="getIsDisabled"
            :class="[
              'activateSwitch',
              !(activateEnabled && getLimitStatus) ? 'disabled' : '',
            ]"
            class="asc-customAlert"
            :value="active"
            :hide-details="true"
            @input="handleToggleActivate"
          ></asc-switch>
        </asc-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AscSwitch from '@/components/atoms/AscSwitch'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTooltip from '@/components/atoms/AscTooltip'
import { CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT } from '@/utilities/appConsts'
export default {
  name: 'AscCustomAlertsHeaderWrapper',

  components: {
    AscSwitch,
    AscAccentButton,
    AscTooltip,
  },

  props: {
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Custom Analytics',
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    activateEnabled: {
      type: Boolean,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    alertType: {
      type: String,
      default: 'fullFlight',
    },
    active: {
      type: Boolean,
      default: false,
    },
    fullFlightActiveCount: {
      type: Number,
      default: 0,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getIsDisabled() {
      return (
        !(this.activateEnabled && this.getLimitStatus) ||
        this.isDataBricksRunning ||
        this.isReadOnly
      )
    },
    getButtonText() {
      return 'Save'
    },
    getSaveDisabled() {
      return this.saveDisabled
    },
    getTooltip() {
      let tooltip = ''
      if (!this.activateEnabled) {
        tooltip = 'Fix all errors to activate custom analytic'
      } else if (
        this.fullFlightActiveCount >=
          CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT &&
        !this.active &&
        (this.alertType === 'fullflight' ||
          this.alertType === 'advanced-fullflight' ||
          this.alertType === 'advanced-dplf')
      ) {
        tooltip = `You have reached your limit of ${CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT} Full Flight/DPLF Data Custom Analytics`
      }
      return tooltip
    },
    getLimitStatus() {
      if (
        this.alertType.includes('fullflight') ||
        this.alertType.includes('dplf')
      ) {
        return !(
          this.fullFlightActiveCount >=
            CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT && !this.active
        )
      } else {
        return true
      }
    },
  },
  methods: {
    handleSave() {
      this.$emit('handleSave')
    },
    handleCancel() {
      this.$emit('handleCancel')
    },
    handleToggleActivate(value) {
      this.$emit('handleToggleActivate', value, true)
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts--header {
  .titleColumn {
    p {
      margin: 10px 0;
    }
  }

  &.isSticky {
    padding-right: 16px;

    .stickyFooter {
      padding: 0 15px;
    }
  }

  .customAlertControls {
    display: flex;
    justify-content: flex-end;

    .asc-accent-button-container {
      margin-top: 0;
      margin-right: 8px;
    }

    .asc-switch {
      margin-top: -6px;

      &.disabled {
        opacity: 0.3;
      }

      .v-input {
        .v-label {
          display: none;
        }
      }
    }
  }
}

.asc-sticky--container .asc-sticky.isSticky.stickyFooter {
  left: 48px !important;
  width: calc(100% - 48px) !important;
}
</style>
